import { Skeleton, Stack } from '@mui/material'
import { FC } from 'react'
import { SkeletonText } from 'utoniq-ui'

import { OrganismFrame } from '@/core/architecture'

export const ExhibitionPeriodSkeleton: FC = () => {
  return (
    <OrganismFrame sx={{ py: 4 }}>
      <Stack sx={{ bgcolor: 'grey.50' }}>
        <Skeleton
          variant="rectangular"
          height={20}
          width="100%"
          sx={{ bgcolor: 'grey.100', my: '6px' }}
        />
      </Stack>
      <SkeletonText variant="small" numberOfLine={2} />
    </OrganismFrame>
  )
}
